<script lang="ts">
	import type { FooterLinks, SEOData } from '$lib/components/seo/types';
	import type { ClassValue } from 'svelte/elements';
	import Legal from '$lib/components/footer/Legal.svelte';
	import SEOFoot from '$lib/components/seo/SEOFoot.svelte';
	import ProductFoot from './ProductFoot.svelte';

	interface Props {
		partnersLinks: FooterLinks[];
		seo?: SEOData | undefined;
		class?: ClassValue;
	}

	const { partnersLinks, seo = undefined, class: classes = '' }: Props = $props();

</script>

<!-- svelte-ignore a11y_no_redundant_roles -->
<footer
	role="contentinfo"
	data-sveltekit-preload-data="tap"
	class="bg-neutral-weakest flex flex-col gap-6 p-2 pb-0 {classes}"
>
	<ProductFoot />
	{#if seo?.footer}
		<SEOFoot {seo} {partnersLinks} />
	{/if}
	<Legal />
</footer>

<style>
	footer :global(:last-child) {
		scroll-snap-align: end;
	}
</style>
